/**
 * „Upgrade erforderlich“-Dialog: erscheint, wenn das Gratis-Tarif-Limit
 * (standardmäßig 3 Projekte) überschritten wird. Bewusst als Overlay statt
 * alert — der Nutzer behält den Bildschirmkontext.
 */
export function showUpgradeNotice(message: string): void {
  const wrap = document.createElement('div');
  wrap.className = 'overlay upgrade-overlay';

  const card = document.createElement('div');
  card.className = 'auth-card';

  const logo = document.createElement('div');
  logo.className = 'logo auth-logo';
  logo.innerHTML =
    '<svg viewBox="0 0 100 100" width="26" height="26"><rect x="8" y="30" width="70" height="45" rx="8" fill="#e0552c"/><circle cx="28" cy="78" r="9" fill="#222"/><circle cx="68" cy="78" r="9" fill="#222"/></svg><span>CampSketch</span>';

  const h1 = document.createElement('h1');
  h1.textContent = 'Upgrade erforderlich';

  const text = document.createElement('p');
  text.className = 'auth-hint';
  text.textContent = message;

  const note = document.createElement('p');
  note.className = 'auth-hint';
  note.textContent =
    'Deine bestehenden Projekte bleiben selbstverständlich erhalten — sie lassen sich weiterhin öffnen, bearbeiten und exportieren.';

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'auth-submit';
  closeBtn.textContent = 'Verstanden';
  closeBtn.onclick = () => wrap.remove();

  const cancel = (e: Event): void => {
    if (e.target === wrap) wrap.remove();
  };
  wrap.addEventListener('mousedown', cancel);
  const esc = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      wrap.remove();
      document.removeEventListener('keydown', esc, true);
    }
  };
  document.addEventListener('keydown', esc, true);

  card.append(logo, h1, text, note, closeBtn);
  wrap.appendChild(card);
  document.body.appendChild(wrap);
}
